import { render } from "./BuddyPlatform.vue?vue&type=template&id=6e0bc2c8&scoped=true"
import script from "./BuddyPlatform.vue?vue&type=script&lang=js"
export * from "./BuddyPlatform.vue?vue&type=script&lang=js"

import "./BuddyPlatform.vue?vue&type=style&index=0&id=6e0bc2c8&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0bc2c8"]])

export default __exports__